import { Component, Host, h, Prop } from '@stencil/core';
import { DomService } from '../../services';

@Component({
  tag: 'rcm-sb-accordion',
  styleUrl: 'rcm-sb-accordion.scss',
  shadow: true,
})
export class RcmSbAccordion {
  @Prop() accordionTitle: string;

  @Prop() accordionToggleMarginTop = false;

  render() {
    return (
      <Host style={{ marginTop: this.accordionToggleMarginTop ? 'var(--spacings-xl)' : '' }}>
        <rcm-accordeon mainTitle={this.accordionTitle} expanded={false} isArticle={DomService.getGlobalConfig().isArticle} isSbComponent>
          <slot name="accordion-content" />
        </rcm-accordeon>
      </Host>
    );
  }
}
